import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, FormattedNumber, IntlProvider } from 'react-intl';
import { Row, Col, OverlayTrigger, Popover, Alert, DropdownButton, MenuItem, Clearfix } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';
import GoogleMap from 'google-map-react';
import scriptLoader from 'react-async-script-loader';

import { getOrderLabels } from 'helpers/order';

import Breadcrumb from 'components/layout/Breadcrumb';
import OrderActions from 'components/layout/order/OrderActions';
import OrderItemsCustomer from 'components/layout/order/OrderItemsCustomer';
import OrderInvoicesPopover from 'components/layout/order/OrderInvoicesPopover';
import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import IntlDateTime from 'components/layout/IntlDateTime';
import MapMarker from 'components/layout/MapMarker';
import WorkingHours from 'components/layout/client/WorkingHours';

import Data from 'components/Data';

import { GOOGLE_MAPS_KEY, GOOGLE_MAPS_URL, mapOptions } from 'js/constants';

class OrderViewVendor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showLocationInfos: false,
    };
  }

  render() {
    const {
      intl: { messages },
      appIntl,
      layout,
      orderId,
      orderData,
      data,
      user,
    } = this.props;

    const pending = orderData ? false : data.pending;
    const order = orderData || data.data;

    let orderActionListItemComponent = null;
    let orderActionsWrapperComponent = null;
    if (!pending && layout.breakpointIndex < 2) {
      const SimpleMenuItemActionElement = ({ key, caption, icon, action }) => (
        <MenuItem key={key} eventKey={key} onClick={action}>
          <i class={'fa-fw ' + icon + ' m-r-5'} /> {caption}
        </MenuItem>
      );
      orderActionListItemComponent = <SimpleMenuItemActionElement />;
      orderActionsWrapperComponent = (
        <DropdownButton id={'input-dropdown-addon-' + order.id} noCaret pullRight title={<i class="fal fa-bars" />} />
      );
    }

    const orderActions = pending ? null : (
      <OrderActions
        order={order}
        wrapperComponent={orderActionsWrapperComponent}
        listItemComponent={orderActionListItemComponent}
        key={'order-actions' + order.id}
      />
    );



    let headerName = messages.order_details;
    let typeIdName = messages.order;
    let orderDateName = messages.order_placed;
    let currentBreadcrumbName = messages.orders;
    let currentBreadcrumbLink = appIntl.urlPrefix + 'account/vendororders';

    return (
      <div class="padding-25 sm-padding-10 relative">
        {orderData !== undefined ? (
          <Data dataName="order" />
        ) : (
          <Data dataName="order" url={`/api/vendororders/${orderId}.json`} data={data} />
        )}

        <Breadcrumb
          crumbs={[
            { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
            { link: currentBreadcrumbLink, name: currentBreadcrumbName },
            { link: null, name: order.id },
          ]}
        />

        {pending ? (
          <Loader />
        ) : (
          <div>
            <h3>
              {getOrderLabels(order, messages)} {headerName}
            </h3>

            <div class="panel b-rad-lg no-overflow b-grey">
              <div class="bg-master-lightest menuclipper padding-20 sm-padding-10">
                <Row>
                  <Col xs={12} sm={6}>
                    <span class="hidden-sm hidden-md hidden-lg block">
                      {typeIdName} #{order.id}
                    </span>
                    {orderDateName} <IntlDate date={order.cdate} />
                    <span class="m-l-10 m-r-10 hint-text hidden-xs">|</span>
                    <span class="hidden-xs">
                      {typeIdName} #{order.id}
                    </span>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div class="text-right xs-text-left">
                      <OverlayTrigger
                        container={this}
                        trigger="click"
                        rootClose
                        placement="bottom"
                        overlay={
                          <Popover id={'order-invoices-' + order.id}>
                            <IntlProvider locale={appIntl.locale} messages={appIntl.messages.messages}>
                              <OrderInvoicesPopover order={order} />
                            </IntlProvider>
                          </Popover>
                        }
                      >
                        <a href="javascript:;" class="inline">
                          <span class="text-primary">{messages.salesDoc.invoice}</span> <i class="fas fa-angle-down" />
                        </a>
                      </OverlayTrigger>
                    </div>
                  </Col>
                </Row>
              </div>
              <div class="panel-body">
                <Row>
                  <Col xs={12} md={4}>
                    <div class="m-b-5 bold">{messages.shipping_address}</div>
                    <div class="">
                      {order.delivery_addresses.map(deliveryAddress => {
                        return(
                          <p>{deliveryAddress.company}</p>
                        );
                      })}
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    {order.type !== 'car_service' && (
                      <React.Fragment>
                        <div class="m-b-5 bold">{messages.payment_method}</div>
                        <div class="">{messages['payment_' + order.payment]}</div>
                      </React.Fragment>
                    )}
                  </Col>
                  <Col xs={12} md={4}>

                      <React.Fragment>
                        <div class="m-b-5 bold">{messages.order_overview}</div>
                        <div class="">
                          <div class="clearfix">
                            <div class="pull-left" />
                            <div class="pull-right" />
                          </div>

                          <div class="clearfix">
                            <div class="pull-left">{messages.salesDoc.amount_due}</div>
                            <div class="pull-right">
                              Betrag oder so
                            </div>
                          </div>



                          <div class="clearfix m-t-5">
                            <div class="pull-left bold">{messages.salesDoc.total}</div>
                            <div class="pull-right bold">
                              Summenzeile
                            </div>
                          </div>
                        </div>
                      </React.Fragment>

                  </Col>
                </Row>
              </div>
            </div>

            <div class="panel b-rad-lg no-overflow b-grey">
              <div class="panel-body">
                <Row>
                  <Col sm={12} md={8} class="relative">
                    {layout.breakpointIndex < 2 ? <div class="top-right">{orderActions}</div> : null}

                    {/* order title */}
                    <h4>{order.reference_text}</h4>

                    {(order.type === 'car_rent' || order.type === 'car_service') && (
                      <React.Fragment>
                        Irgendwas
                      </React.Fragment>
                    )}

                    {/* item list
                    <OrderItemsCustomer order={order} />*/}
                  </Col>
                  <Col xsHidden smHidden md={4} class="p-t-30">
                    {layout.breakpointIndex > 1 ? orderActions : null}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
OrderViewVendor.defaultProps = {};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    layout: state.layout,
    data: state.data.order,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)((OrderViewVendor))));
